import React from 'react';
import LinkList from '../components/LinkList';

const Links = () => {
  return <LinkList />;
};

export default Links;
